import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './styles.css'


function Integraciones_ecommerce() {

    return (
        <Container className='contenedorinicial'>
            <Row><div className="ag_title">INTEGRACIONES ECOMMERCE</div></Row>
            <Row>
                <Col>
                    <p className="ag_parrafo">
                        Amplía tus servicios de pago a comercios a cualquier país con el software mejor calificado de paytowns.
                    </p>
                    <p className="ag_parrafo">
                        Gracias al backoffice en línea ininterrupido, nuestro sistema detecta actividad sospechosa en tiempo real.
                    </p>
                    <p className="ag_parrafo">
                        Recibe pagos con todas las tarjetas y en las principales plataformas de comercio electrónico.
                    </p>
                    <p className="ag_parrafo">
                        Impulsa tu negocio con las mejores soluciones y más avanzadas que se integran a tus sistemas de ventas.
                    </p>
                </Col>
                <Col className="box-imgag_container" xs={12} md={6}>
                                <img className='section-img' src="/assets/img/integraciones-con-ecommerce.png" alt="" />
                        </Col>
            </Row>
            
            {/* <div class="card text-center">
                <div class="card-header">
                    PAGOS LOCALES
                </div>
                <div class="card-body">
                    <h5 class="card-title">Special title treatment</h5>
                    <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                    <a href="#" class="btn btn-primary">Go somewhere</a>
                </div>
                <div class="card-footer text-muted">
                    2 days ago
                </div>
            </div>



            <Row>
                <Col className='box-text text-center' xs={12} md={6}>
                    <h2>PAGOS LOCALES</h2>
                </Col>
    </Row> */}
        </Container>
    );
};

export default Integraciones_ecommerce;